import { ZOOM } from "../actions/utilities";

const INITIAL_STATE = {
  getAllMeetingsLoading: false,
  getAllMeetingsSuccess: false,
  getAllMeetingsFailure: false,
  getAllMeetingsError: null,
  allMeetingsList: [],

  getUserLoading: false,
  getUserSuccess: false,
  getUserFailure: false,
  getUserError: null,
  user: [],

  createScheduleMeetingLoading: false,
  createScheduleMeetingSuccess: false,
  createScheduleMeetingFailure: false,
  createScheduleMeetingError: null,
  createScheduleMeeting: null,

  updateScheduleMeetingLoading: false,
  updateScheduleMeetingSuccess: false,
  updateScheduleMeetingFailure: false,
  updateScheduleMeetingError: null,
  updateScheduleMeeting: null,

  getSingleMeetingLoading: false,
  getSingleMeetingSuccess: false,
  getSingleMeetingFailure: false,
  getSingleMeetingError: null,
  getSingleMeeting: null,

  instantMeetingLoading: false,
  instantMeetingSuccess: false,
  instantMeetingFailure: false,
  instantMeetingError: null,
  instantMeeting: null,
};

export const zoomReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ZOOM.GET_ALL_MEETINGS_REQUEST:
      return {
        ...state,
        getAllMeetingsLoading: true,
        getAllMeetingsSuccess: false,
        getAllMeetingsFailure: false,
        getAllMeetingsError: null,
      };
    case ZOOM.GET_ALL_MEETINGS_SUCCESS:
      return {
        ...state,
        getAllMeetingsLoading: false,
        getAllMeetingsSuccess: true,
        getAllMeetingsFailure: false,
        getAllMeetingsError: null,
        allMeetingsList: action.payload,
      };
    case ZOOM.GET_ALL_MEETINGS_FAILURE:
      return {
        ...state,
        getAllMeetingsLoading: false,
        getAllMeetingsSuccess: false,
        getAllMeetingsFailure: true,
        getAllMeetingsError: action.payload,
      };

    case ZOOM.CREATE_INSTANT_MEETING_REQUEST:
      return {
        ...state,
        instantMeetingLoading: true,
        instantMeetingSuccess: false,
        instantMeetingFailure: false,
        instantMeetingError: null,
      };
    case ZOOM.CREATE_INSTANT_MEETING_SUCCESS:
      return {
        ...state,
        instantMeetingLoading: false,
        instantMeetingSuccess: true,
        instantMeetingFailure: false,
        instantMeetingError: null,
      };
    case ZOOM.CREATE_INSTANT_MEETING_FAILURE:
      return {
        ...state,
        instantMeetingLoading: false,
        instantMeetingSuccess: false,
        instantMeetingFailure: true,
        instantMeetingError: action.payload,
      };

    case ZOOM.CREATE_SCHEDULE_MEETING_REQUEST:
      return {
        ...state,
        createScheduleMeetingLoading: true,
        createScheduleMeetingSuccess: false,
        createScheduleMeetingFailure: false,
        createScheduleMeetingError: null,
      };
    case ZOOM.CREATE_SCHEDULE_MEETING_SUCCESS:
      // let client_ = [action.payload, ...state.allMeetingsList];
      // client_?.push(action.payload);
      return {
        ...state,
        createScheduleMeetingLoading: false,
        createScheduleMeetingSuccess: true,
        createScheduleMeetingFailure: false,
        createScheduleMeetingError: null,
        createScheduleMeeting: action.payload,
        // allMeetingsList: client_,
      };
    case ZOOM.CREATE_SCHEDULE_MEETING_FAILURE:
      return {
        ...state,
        createScheduleMeetingLoading: false,
        createScheduleMeetingSuccess: false,
        createScheduleMeetingFailure: true,
        createScheduleMeetingError: action.payload,
      };

    case ZOOM.UPDATE_SCHEDULE_MEETING_REQUEST:
      return {
        ...state,
        updateScheduleMeetingLoading: true,
        updateScheduleMeetingSuccess: false,
        updateScheduleMeetingFailure: false,
        updateScheduleMeetingError: null,
      };
    case ZOOM.UPDATE_SCHEDULE_MEETING_SUCCESS:
      let meeting_list_update = state.allMeetingsList;
      for (var i = 0; i < meeting_list_update.length; i++) {
        if (meeting_list_update[i]._id === action.payload._id) {
          meeting_list_update[i] = action.payload;
        }
      }
      return {
        ...state,
        updateScheduleMeetingLoading: false,
        updateScheduleMeetingSuccess: true,
        updateScheduleMeetingFailure: false,
        updateScheduleMeetingError: null,
        allMeetingsList: meeting_list_update,
      };
    case ZOOM.UPDATE_SCHEDULE_MEETING_FAILURE:
      return {
        ...state,
        updateScheduleMeetingLoading: false,
        updateScheduleMeetingSuccess: false,
        updateScheduleMeetingFailure: true,
        updateScheduleMeetingError: action.payload,
      };

    case ZOOM.ZOOM_OAUTH_REQUEST:
      return {
        ...state,
        getUserLoading: true,
        getUserSuccess: false,
        getUserFailure: false,
        getUserError: null,
        user: null,
      };
    case ZOOM.ZOOM_OAUTH_SUCCESS:
      return {
        ...state,
        getUserLoading: false,
        getUserSuccess: true,
        getUserFailure: false,
        getUserError: null,
        user: action.payload,
      };
    case ZOOM.ZOOM_OAUTH_FAILURE:
      return {
        ...state,
        getUserLoading: false,
        getUserSuccess: false,
        getUserFailure: true,
        getUserError: action.payload,
        user: null,
      };

    case ZOOM.GET_SINGLE_MEETING_REQUEST:
      return {
        ...state,
        getSingleMeetingLoading: true,
        getSingleMeetingSuccess: false,
        getSingleMeetingFailure: false,
        getSingleMeetingError: null,
      };
    case ZOOM.GET_SINGLE_MEETING_SUCCESS:
      return {
        ...state,
        getSingleMeetingLoading: false,
        getSingleMeetingSuccess: true,
        getSingleMeetingFailure: false,
        getSingleMeetingError: null,
        getSingleMeeting: action.payload,
      };
    case ZOOM.GET_SINGLE_MEETING_FAILURE:
      return {
        ...state,
        getSingleMeetingLoading: false,
        getSingleMeetingSuccess: false,
        getSingleMeetingFailure: true,
        getSingleMeetingError: action.payload,
      };

    default:
      return state;
  }
};
